import React from 'react';
import { useParams } from 'react-router-dom';

import KeyChip from '@dashboard/components/KeyChip';
import { BuildOutlined, OndemandVideoOutlined, OpenInNewOutlined } from '@mui/icons-material';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';

import CodeExamplesLink from './CodeExamplesLink';

export default function StartSendingCallout() {
  const id = useParams<{ id: string }>().id!;

  return (
    <Stack spacing={1} sx={{ borderTop: '1px solid', borderColor: 'divider', p: 3 }}>
      <Typography fontWeight="medium">Use this template</Typography>

      <List disablePadding dense sx={{ pb: 2 }}>
        <ListItem disablePadding dense>
          <CodeExamplesLink />
        </ListItem>

        <ListItem disablePadding dense>
          <ListItemButton href="https://www.usewaypoint.com/docs/quickstart" target="_blank">
            <ListItemIcon sx={{ minWidth: 32 }}>
              <OndemandVideoOutlined sx={{ fontSize: 18 }} />
            </ListItemIcon>
            <ListItemText primary="Quick start tutorial" />
            <OpenInNewOutlined sx={{ fontSize: 16, color: 'grey.500' }} />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding dense>
          <ListItemButton href="https://www.usewaypoint.com/docs/template-basics" target="_blank">
            <ListItemIcon sx={{ minWidth: 32 }}>
              <BuildOutlined sx={{ fontSize: 18 }} />
            </ListItemIcon>
            <ListItemText primary="Template builder basics" />
            <OpenInNewOutlined sx={{ fontSize: 16, color: 'grey.500' }} />
          </ListItemButton>
        </ListItem>
      </List>

      <KeyChip label={id} tooltipTitle="Copy template ID to clipboard" />
    </Stack>
  );
}
